// Container Trader homepage configuration.
// Listing type ids and category ids come from the hosted (Console) configuration.
// They are referenced here only for search links; nothing here changes listing data.

export const HELPLINE_DISPLAY = '1-844-321-2876';
export const HELPLINE_TEL = '+18443212876';

export const LISTING_TYPE_MANAGED = 'container-trader-managed';
// Dealer Pro Buy It Now listings (see src/util/ctSellerPlan.js).
export const LISTING_TYPE_DEALER_BUY_IT_NOW = 'dealer-buy-it-now';
// Every Buy It Now listing: Container Trader Managed Deals + Dealer Pro Buy It Now.
export const BUY_IT_NOW_LISTING_TYPES = `${LISTING_TYPE_MANAGED}%2C${LISTING_TYPE_DEALER_BUY_IT_NOW}`;

// Search query strings (without leading "?")
export const SEARCH = {
  buyItNow: `pub_listingType=${BUY_IT_NOW_LISTING_TYPES}`,
  size20: 'pub_listingType=20',
  size40: 'pub_listingType=40',
  size40hc: 'pub_listingType=40hc',
  size45hc: 'pub_listingType=45hc',
  office: 'pub_listingType=office',
  modified: 'pub_listingType=office%2Cmod',
  reefer: 'pub_listingType=refer',
  rental: 'pub_listingType=rental',
  oneTrip: 'pub_categoryLevel1=1trip',
  cargoWorthy: 'pub_categoryLevel1=cw',
  wwt: 'pub_categoryLevel1=wwt',
  iicl: 'pub_categoryLevel1=iicl',
  loads: 'pub_categoryLevel1=Transport-needed&pub_listingType=Transportation_Services',
  trucks: 'pub_categoryLevel1=transport-offered&pub_listingType=Transportation_Services',
};

// Post-a-listing draft URL used by the existing site (wanted ads / quotes)
export const NEW_LISTING_PATH = '/l/draft/00000000-0000-0000-0000-000000000000/new/details';

export const SIZE_CARDS = [
  {
    key: '20',
    title: "20' Standard",
    detail: '8\u2032 wide \u00b7 8\u20326\u2033 tall \u00b7 ~1,170 cu ft',
    use: 'Storage, job sites, farms',
    image: '/static/images/ct/size-20-std.jpg',
    search: SEARCH.size20,
  },
  {
    key: '40hc',
    title: "40' High Cube",
    detail: '8\u2032 wide \u00b7 9\u20326\u2033 tall \u00b7 ~2,690 cu ft',
    use: 'Most space per dollar',
    image: '/static/images/ct/size-40hc.jpg',
    search: SEARCH.size40hc,
  },
  {
    key: '40',
    title: "40' Standard",
    detail: '8\u2032 wide \u00b7 8\u20326\u2033 tall \u00b7 ~2,390 cu ft',
    use: 'Bulk storage, shipping',
    image: '/static/images/ct/size-40-std.jpg',
    search: SEARCH.size40,
  },
  {
    key: 'specialty',
    title: 'Office & Modified',
    detail: 'Doors, windows, power, HVAC',
    use: 'Offices, shops, custom builds',
    image: '/static/images/ct/size-office.jpg',
    search: SEARCH.modified,
  },
];

export const CONDITION_CHIPS = [
  { label: 'One-Trip / New', search: SEARCH.oneTrip },
  { label: 'IICL', search: SEARCH.iicl },
  { label: 'Cargo Worthy', search: SEARCH.cargoWorthy },
  { label: 'Wind & Water Tight', search: SEARCH.wwt },
];

// Popular markets. Bounds: NE lat,NE lng,SW lat,SW lng (about a 45-mile box)
const box = (lat, lng, d = 0.4) =>
  `${(lat + d).toFixed(4)},${(lng + d).toFixed(4)},${(lat - d).toFixed(4)},${(lng - d).toFixed(4)}`;

export const CITIES = [
  { name: 'Salt Lake City', st: 'UT', lat: 40.7608, lng: -111.891 },
  { name: 'Denver', st: 'CO', lat: 39.7392, lng: -104.9903 },
  { name: 'Phoenix', st: 'AZ', lat: 33.4484, lng: -112.074 },
  { name: 'Los Angeles', st: 'CA', lat: 34.0522, lng: -118.2437 },
  { name: 'Dallas', st: 'TX', lat: 32.7767, lng: -96.797 },
  { name: 'Houston', st: 'TX', lat: 29.7604, lng: -95.3698 },
  { name: 'Chicago', st: 'IL', lat: 41.8781, lng: -87.6298 },
  { name: 'Atlanta', st: 'GA', lat: 33.749, lng: -84.388 },
  { name: 'Savannah', st: 'GA', lat: 32.0809, lng: -81.0912 },
  { name: 'Seattle', st: 'WA', lat: 47.6062, lng: -122.3321 },
  { name: 'Kansas City', st: 'MO', lat: 39.0997, lng: -94.5786 },
  { name: 'New York', st: 'NY', lat: 40.7128, lng: -74.006 },
].map(c => ({
  ...c,
  search: `address=${encodeURIComponent(`${c.name}, ${c.st}, USA`)}&bounds=${encodeURIComponent(
    box(c.lat, c.lng)
  )}`,
}));
